export const newsActions = {
  GET_ARTICLES_PENDING: 'GET_ARTICLES_PENDING',
  GET_ARTICLES_SUCCESS: 'GET_ARTICLES_SUCCESS',
  GET_ARTICLES_ERROR: 'GET_ARTICLES_ERROR',
};
